import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';

enum DocumentationTab {
  general,
  XemexPortal,
  MechanicApp,
  Invoices,
  Settings,
}

const TABS_MOCKS = [
  {
    index: DocumentationTab.general,
    title: 'documentation.tabs.general.label',
  },
  {
    index: DocumentationTab.XemexPortal,
    title: 'documentation.tabs.xemexPortal.label',
  },
  {
    index: DocumentationTab.MechanicApp,
    title: 'documentation.tabs.mechanicApp.label',
  },
  {
    index: DocumentationTab.Invoices,
    title: 'documentation.tabs.invoices.label',
  },
  {
    index: DocumentationTab.Settings,
    title: 'documentation.tabs.settings.label',
  },
];

@Component({
  selector: 'xemex-documentation-page',
  imports: [MatFormFieldModule, MatInputModule, MatIconModule, TranslateModule],
  templateUrl: './documentation-page.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './documentation-page.component.scss',
})
export class DocumentationPageComponent {
  TABS_MOCKS = TABS_MOCKS;
  tabSelected = DocumentationTab.general;

  onTabClick(index: number) {
    this.tabSelected = index;
  }
}
